// Tolerance of the soft obstacle decision (web spec SW-PA-02, SW-PA-03), entered in minutes, stored in seconds.
export const TOLERANCE_MIN_MAX = 15;
export const TOLERANCE_MIN_STEP = 0.5;

/** Course settings (chantier Parcours §1.4): wider bounds than S / P, the same minute entry. */
export const COURSE_TOLERANCE_MIN_MAX = 60;
export const COURSE_RELATIVE_PCT_MAX = 100;
export const COURSE_CROSSING_S_MAX = 600;
export const COURSE_CROSSING_S_STEP = 5;

/** Engine defaults of the course settings, used when a global value is absent (older server, SW-PA-01). */
export const COURSE_DEFAULTS = {
  courseToleranceAbsoluteS: 600,
  courseToleranceRelative: 0.5,
  courseCrossingPenaltyS: 45,
} as const;
export type CourseSettingKey = keyof typeof COURSE_DEFAULTS;

export function secondsToMinutes(s: number): number {
  return Math.round((s / 60) * 2) / 2;
}

export function minutesToSeconds(min: number, maxMin: number = TOLERANCE_MIN_MAX): number {
  const clamped = Math.min(maxMin, Math.max(0, min));
  return Math.round(clamped * 60);
}

/** Longest accepted detour for a trip of `tripS` seconds: the larger of the absolute and relative tolerances (core Tolerance.thresholdS). */
export function thresholdS(absoluteS: number, relative: number, tripS: number): number {
  return Math.max(absoluteS, relative * tripS);
}

/** Clamped crossing penalty in whole seconds. */
export function crossingPenaltyS(s: number): number {
  return Math.round(Math.min(COURSE_CROSSING_S_MAX, Math.max(0, s)));
}
